import Headroom from 'headroom.js';
import {find, fire, on, addClass, removeClass, hasClass} from '../helpers';

const header = find('[data-header]');
const stickyBar = find('[data-sticky-bar]');

const update = (elem, add, remove) => {
    removeClass(elem, remove);
    addClass(elem, add);

    return null;
};

on('trigger-solid', () => {
    if (hasClass(header, 'is-transparent')) {
        addClass(header, 'default-nav');
    }
});

on('trigger-transparent', () => {
    if (hasClass(header, 'is-transparent')) {
        removeClass(header, 'default-nav');
    }
});

new Headroom(header, {
    offset: header.clientHeight,
    onPin: () => fire('sticky-sidebars::change', update(stickyBar, 'top-28', 'top-16')),
    onBottom: () => fire('sticky-sidebars::change', update(stickyBar, 'top-28', 'top-16')),
    onUnpin: () => {
        fire('dropdown-close');
        fire('trigger-solid');
        fire('sticky-sidebars::change', update(stickyBar, 'top-16', 'top-28'));
    },
    onTop: () => fire('trigger-transparent'),
    onNotTop: () => {
        fire('trigger-solid');
        fire('sticky-sidebars::change', update(stickyBar, 'top-28', 'top-16'));
        if (window.innerWidth > 1024) {
            fire('close-menu', window);
        }
    },
}).init();
